import { Tag } from "./tag";

interface TagsProps {
  tags: string[];
  className?: string;
}

export const Tags = ({ tags, className }: TagsProps) => {
  return (
    <div className={`flex flex-wrap gap-[6.5px] ${className}`}>
      {tags.map((item, i) => (
        <Tag key={i} value={item} />
      ))}
    </div>
  );
};
